export enum L1ReviewStatus {
  PENDING = "PENDING",
  AUTHORIZED = "AUTHORIZED",
  SUSPENDED = "SUSPENDED",
  REJECTED = "REJECTED",
  ESCALATED = "ESCALATED",
  SLA_BREACHED = "SLA_BREACHED",
}

export enum L1TriggerReason {
  PEP_HIT = "PEP_HIT",
  SANCTIONS_HIT = "SANCTIONS_HIT",
  ADVERSE_MEDIA = "ADVERSE_MEDIA",
  FATF_GRAY_LIST = "FATF_GRAY_LIST",
  /** Score de risque élevé, sans correspondance nominative. */
  HIGH_RISK = "HIGH_RISK",
  /** Revue ouverte à la main par un agent, sans déclencheur automatique. */
  MANUAL = "MANUAL",
  /** Réponse du service externe non reçue au-delà du seuil. */
  VNEURONE_WEBHOOK_TIMEOUT = "VNEURONE_WEBHOOK_TIMEOUT",
  /**
   * Le contrôle d'éligibilité externe a refusé le dossier - refus rendu dès l'appel sur une règle
   * bloquante (un pays de la liste noire du GAFI, le plus souvent), ou décision défavorable reçue
   * après instruction. Le motif existait côté back sans exister ici : l'écran affichait « Motif
   * non reconnu » sur le seul élément qui disait à l'analyste pourquoi il devait trancher.
   */
  EXTERNAL_ELIGIBILITY_REFUSED = "EXTERNAL_ELIGIBILITY_REFUSED",
  /**
   * Nationalité d'un pays sanctionné, sans PEP associé. Distinct de HIGH_RISK (générique, sans
   * raison connue) et de SANCTIONS_HIT (correspondance nominative sur liste) : ici la classification
   * est forcée par le pays lui-même (incident 2026-09-07, aaa0905/aaa0906/aaa0909 — Iran).
   */
  SANCTIONED_COUNTRY = "SANCTIONED_COUNTRY",
  /**
   * Motif envoyé par le back mais inconnu de cette version du front. Existe pour que l'écran
   * l'avoue au lieu de le faire passer pour autre chose : le mapping repliait tout motif inconnu
   * sur « Manuel », et l'agent lisait qu'un collègue avait saisi la revue à la main alors qu'elle
   * venait d'un déclenchement automatique.
   */
  UNKNOWN = "UNKNOWN",
}

export interface L1ReviewItem {
  /**
   * Correspondances encore à trancher. Sépare la file : un rapprochement à qualifier est fréquent
   * et se traite vite, une correspondance retenue est un signal fort et rare. Les mélanger
   * produirait une file où tout paraît urgent — donc une file que plus personne ne regarde.
   */
  matchesToQualify?: number | null;
  /** Correspondances retenues par un agent — le signal fort. */
  matchesConfirmed?: number | null;
  reviewId: string;
  scoringEventId: string;
  businessKey: string;
  // FE-4 — identité client (résolue back) pour la colonne Nom ; null si client introuvable.
  firstName: string | null;
  lastName: string | null;
  // FE-4 — classification de risque réelle (risk_profile_audit.risk_class : LOW/STANDARD/HIGH) ; null si absente.
  riskLevel: string | null;
  status: L1ReviewStatus;
  triggerReason: L1TriggerReason;
  // Nullable: the backend returns null when VNeurone (track scoring) is disabled.
  trackAScore: number | null;
  trackBScore: number | null;
  slaDeadline: string;
  slaExpired: boolean;
  // us-l1r-03 — assignation P3 : login de l'agent assigné (null si non attribué) + horodatage.
  assignedTo: string | null;
  assignedAt: string | null;
  createdAt: string;
}
